import React from 'react';
import SEOHead from '../seo/SEOHead';
import PageHeader from '../components/PageHeader';

const MinistryInfectious = () => {
  return (
    <>
      <SEOHead path="/ministry-for-people-with-acute-infectious-diseases" />
      <PageHeader title="Ministry for People with Acute Infectious Diseases" breadcrumb="Ministry for People with Acute Infectious Diseases" />

      <section className="section">
        <div className="container">
          <div className="content-page fade-in">
            <div className="content-body">
              <p>At Teen Challenge Armenia, we believe in reaching those whose lives have been overshadowed by acute infectious diseases. Our specialized Ministry for People with Acute Infectious Diseases, led by Arman Avchyan, manifests this commitment. These individuals are often identified during our outreach activities for the homeless, reflecting the multifaceted nature of our work.</p>

              <p>Our dedicated team goes beyond their call of duty, braving the risks associated with infectious diseases to provide care to those in desperate need. With love and unwavering commitment, they touch the lives of these individuals, offering them a beacon of hope in their darkest hours.</p>

              <p>Upon identification, these individuals are immediately admitted to local hospitals to receive appropriate treatment and care. We ensure that illness does not become a deterrent in their journey to a better life. For those who cannot go back to their homes after treatment, Teen Challenge Armenia offers a place to stay, supporting their recovery in a safe and caring environment.</p>

              <p>But our support for these individuals does not stop at immediate treatment and housing. Understanding that continual care is key to full recovery, our ministry consistently follows up with these individuals, providing them with the necessary food, medication, and clothing. This sustained support not only prevents their diseases from worsening but also curbs the spread of these diseases, contributing to a healthier community at large.</p>

              <p>In this difficult journey from illness and fear to health and hope, the Ministry for People with Acute Infectious Diseases stands as a resolute companion. Our conviction rests on the belief that everyone deserves a shot at a healthier, dignified life, and we are committed to turning this belief into a reality. With the grace of God and your support, we strive to reach the unreached and serve the underserved.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MinistryInfectious;
